/**
 * P-325 · the Update feed breadcrumb's segments, with monday's hrefs
 * (`discovery/ui-reference/notifications/_notes-round11o.json`). Kept out of the component file
 * so the component module exports components only (fast refresh).
 */
import { boardUrl, groupUrl, itemRelativeLink } from '../shell/urls';
import type { InboxRowView } from './types';

export type FeedBreadcrumbRow = Pick<
  InboxRowView,
  'id' | 'boardId' | 'boardName' | 'groupId' | 'groupTitle' | 'itemId' | 'itemName'
>;

/** The segments of one card, in monday's order, with monday's hrefs. */
export function feedBreadcrumbSegments(row: FeedBreadcrumbRow) {
  const segments: { kind: 'board' | 'group' | 'item'; text: string; href: string }[] = [
    { kind: 'board', text: row.boardName ?? row.boardId, href: boardUrl(row.boardId) },
  ];
  if (row.groupId && row.groupTitle) {
    segments.push({ kind: 'group', text: row.groupTitle, href: groupUrl(row.boardId, row.groupId) });
  }
  segments.push({ kind: 'item', text: row.itemName ?? row.itemId, href: itemRelativeLink(row.boardId, row.itemId) });
  return segments;
}
